import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PreloadImagesService {
  images: HTMLImageElement[] = [];

  constructor() {}

  preload(imageNames: string[]) {
    imageNames.forEach((imageName) => {
      const image = new Image();
      image.src = `assets/images/${imageName}`;
      this.images.push(image);
    });
  }
}
